/**
 * Browser entry: hydrate the server-rendered document, then run as a pure SPA
 * over one WebSocket. There is no fetch() to our own server anywhere.
 */
import { hydrateRoot } from 'react-dom/client';
import { App } from './App.tsx';
import { bootstrap, setOnAuthenticated } from './transport/socket.ts';
import { syncThemeFromServer } from './theme.ts';
import { SSR_STATE_ELEMENT_ID } from '../shared/constants.ts';
import { DEFAULT_THEME, isTheme } from '../shared/theme.ts';
import { initTheme } from './theme.ts';
import './styles/app.css';

function readState(): unknown {
  const el = document.getElementById(SSR_STATE_ELEMENT_ID);
  if (!el?.textContent) return null;
  try {
    return JSON.parse(el.textContent);
  } catch {
    return null;
  }
}

// До гидратации: тема должна быть применена раньше первого рендера, иначе
// страница мигнёт не тем цветом.
const ssrState = readState() as { theme?: unknown } | null;
initTheme(isTheme(ssrState?.theme) ? ssrState.theme : DEFAULT_THEME);

const root = document.getElementById('root');
if (root) {
  setOnAuthenticated(syncThemeFromServer);
  hydrateRoot(root, <App />);
  // Decides what to show; entering the console is a separate, human action.
  void bootstrap();
}
